"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhatsAppGroupForm = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const nest_interconnectors_1 = require("@rws-framework/nest-interconnectors");
const component_1 = require("@front/components/site-menu/component");
const uuid_1 = require("uuid");
//@ts-ignore                
let rwsTemplate = T.html `<div class="whatsapp-group-form container-fluid">
    <div class="mb-2">
        <h1>${'whatsapp.groupForm.title'.t()}</h1>
        <div class="text-zero top-right-button-container">
            <button @click="${x => x.goBack()}" type="button"
              class="top-right-button mr-1 btn btn-primary btn-lg">${'whatsapp.groupForm.back'.t()}</button>
        </div>
    </div>

    <form class="card card-body shadow-sm" @submit="${(x, c) => x.handleSubmit(c.event)}">
            
            <div class="form-group mb-3">
                <label class="form-label">${'whatsapp.groupForm.name'.t()} <span class="text-danger">*</span></label>
                <input
                    type="text"
                    class="form-control"
                    placeholder="${'whatsapp.groupForm.namePlaceholder'.t()}"
                    :value="${x => x.formName}"
                    @input="${(x, c) => x.handleNameInput(c.event)}"
                    ?disabled="${x => x.saving}"
                />
            </div>

            
            <div class="form-group mb-4">
                <label class="form-label">${'whatsapp.groupForm.inviteMembers'.t()}</label>
                <div class="d-flex gap-2 mb-2">
                    <input
                        type="text"
                        class="form-control"
                        placeholder="${'whatsapp.groupForm.memberPlaceholder'.t()}"
                        :value="${x => x.newEntry}"
                        @input="${(x, c) => x.handleNewEntryInput(c.event)}"
                        ?disabled="${x => x.saving}"
                    />
                    <button
                        type="button"
                        class="btn btn-outline-primary flex-shrink-0"
                        @click="${x => x.addEntry()}"
                        ?disabled="${x => x.saving}"
                    >
                        <i class="simple-icon-plus mr-1"></i>${'whatsapp.groupForm.addMember'.t()}
                    </button>
                </div>

                ${(0, fast_element_1.when)(x => x.inviteEntries.length === 0, (0, fast_element_1.html) `
                    <p class="text-muted small mb-0">${'whatsapp.groupForm.noMembersYet'.t()}</p>
                `)}

                ${(0, fast_element_1.when)(x => x.inviteEntries.length > 0, (0, fast_element_1.html) `
                    <ul class="list-group">
                        ${(0, fast_element_1.repeat)(x => x.inviteEntries, (0, fast_element_1.html) `
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <span>${p => p.value}</span>
                                <button
                                    type="button"
                                    class="btn btn-sm btn-danger"
                                    @click="${(p, c) => c.parent.removeEntry(p)}"
                                >
                                    <i class="simple-icon-trash"></i>
                                </button>
                            </li>
                        `)}
                    </ul>
                `)}
            </div>

            <div class="form-group mb-4">
                <label class="form-label">${'whatsapp.groupForm.pinMessage'.t()}</label>
                <part-textarea class="form-part" :value="${x => x.pinMessage}" name="pinMessage" rows="4"
                    placeholder="${'whatsapp.groupForm.pinMessagePlaceholder'.t()}"
                    @change="${(x, c) => x.handlePinMessageInput(c.event)}"
                    ?disabled="${x => x.saving}"></part-textarea>
                <div class="form-text">${'whatsapp.groupForm.pinMessageHint'.t()}</div>
            </div>

            <div class="d-flex justify-content-end gap-2">
                <button type="button" class="btn btn-secondary" @click="${x => x.goBack()}" ?disabled="${x => x.saving}">
                    ${'whatsapp.groupForm.cancel'.t()}
                </button>
                <button type="submit" class="btn btn-primary" ?disabled="${x => x.saving}">
                    ${(0, fast_element_1.when)(x => x.saving, (0, fast_element_1.html) `<app-loader block="true" width="15px" height="15px"></app-loader>`)}
                    ${(0, fast_element_1.when)(x => !x.saving, (0, fast_element_1.html) `${'whatsapp.groupForm.save'.t()}`)}
                </button>
            </div>
        </form>
</div>`;
require("./styles/layout.scss");
const styles = T.css `:host {
  display: block;
  width: 100%;
}

.whatsapp-group-form {
  width: 100%;
}
.whatsapp-group-form .top-right-button-container {
  float: right;
}
.whatsapp-group-form .list-group-item {
  padding: 0.5rem 1rem;
}
.whatsapp-group-form .gap-2 {
  gap: 0.5rem;
}`;
const shadowOptions = { "mode": "open" };
let WhatsAppGroupForm = class WhatsAppGroupForm extends client_1.RWSViewComponent {
    constructor(wsService) {
        super();
        this.wsService = wsService;
        this.saving = false;
        this.inviteEntries = [];
        this.newEntry = '';
        this.formName = '';
        this.pinMessage = '';
    }
    async connectedCallback() {
        super.connectedCallback();
        this.wsService.listenForMessage('comms_point', (wsResponse) => {
            const result = wsResponse.data;
            this.saving = false;
            if (result.success) {
                this.notifyService.notify('whatsapp.groupForm.createSuccess'.t(), 'info');
                component_1.SiteMenu.goto.bind(this)('/settings/comms');
            }
            else {
                this.notifyService.notify(result.error || 'whatsapp.groupForm.createFailed'.t(), 'error');
            }
        }, 'comms_create_group_result');
    }
    handleNameInput(event) {
        this.formName = event.target.value;
    }
    handleNewEntryInput(event) {
        this.newEntry = event.target.value;
    }
    handlePinMessageInput(event) {
        var _a;
        const detail = event.detail;
        this.pinMessage = (_a = detail === null || detail === void 0 ? void 0 : detail.value) !== null && _a !== void 0 ? _a : event.target.value;
    }
    addEntry() {
        const val = this.newEntry.trim();
        if (!val)
            return;
        this.inviteEntries = [...this.inviteEntries, { id: (0, uuid_1.v4)(), value: val }];
        this.newEntry = '';
    }
    removeEntry(entry) {
        this.inviteEntries = this.inviteEntries.filter(p => p.id !== entry.id);
    }
    async handleSubmit(event) {
        var _a;
        event.preventDefault();
        if (!this.formName.trim()) {
            this.notifyService.notify('whatsapp.groupForm.nameRequired'.t(), 'error');
            return;
        }
        const settingsId = Number((_a = this.routeParams) === null || _a === void 0 ? void 0 : _a.settingsId);
        if (!settingsId || Number.isNaN(settingsId)) {
            this.notifyService.notify('whatsapp.groupForm.settingsRequired'.t(), 'error');
            return;
        }
        this.wsService.sendMessage('comms_point', 'comms_create_group', {
            settingsId,
            name: this.formName.trim(),
            invitePhoneNumbers: this.inviteEntries.map(p => p.value),
            pinMessage: this.pinMessage.trim() || undefined
        });
        // on success: saving stays true, result arrives via comms_create_group_result WS event
    }
    goBack() {
        component_1.SiteMenu.goto.bind(this)('/settings/comms');
    }
};
exports.WhatsAppGroupForm = WhatsAppGroupForm;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppGroupForm.prototype, "saving", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], WhatsAppGroupForm.prototype, "inviteEntries", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], WhatsAppGroupForm.prototype, "newEntry", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], WhatsAppGroupForm.prototype, "formName", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], WhatsAppGroupForm.prototype, "pinMessage", void 0);
exports.WhatsAppGroupForm = WhatsAppGroupForm = __decorate([
    (0, client_1.RWSView)('whatsapp-group-form', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(nest_interconnectors_1.WSService)),
    __metadata("design:paramtypes", [typeof (_a = typeof nest_interconnectors_1.WSServiceInstance !== "undefined" && nest_interconnectors_1.WSServiceInstance) === "function" ? _a : Object])
], WhatsAppGroupForm);
WhatsAppGroupForm.defineComponent();
exports.default = WhatsAppGroupForm;
